import { useCallback } from 'react';
import { useSelector } from 'react-redux';

// STORY-011: builds a symbol's tokened Wharf logo URL. The token is read live
// from Redux so a token refresh re-renders subscribers with fresh URLs. Wharf
// keys icons without the exchange suffix, so `JP:7203-TS` becomes `JP:7203`.
const useIconUrl = () => {
  const token = useSelector((state) => state.user.token);

  return useCallback(
    (symbol) => {
      const icon = symbol.replace(/-[^-]*$/, '');
      return `https://${process.env.REACT_APP_WHARF_HOSTNAME}/icons/${icon}.png?token=${token}`;
    },
    [token]
  );
};

export default useIconUrl;
